import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import locale from 'date-fns/locale/bg'

export default (value) => {
  return formatDistanceToNow(value * 1000, {addSuffix: true, locale})
}